<template>
  <el-dialog
    :title="title"
    :visible.sync="updatePwd"
    width="30%"
    @update:visible="onVisibleChange"
  >
    <el-form
      :model="pwdForm"
      :rules="loginFormRules"
      ref="pwdForm"
      label-width="100px"
    >
      <el-form-item label="旧密码" prop="oldPassword">
        <el-input
          type="password"
          v-model="pwdForm.oldPassword"
          placeholder="请输入旧密码"
        ></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPassword">
        <el-input
          type="password"
          v-model="pwdForm.newPassword"
          placeholder="请输入新密码"
          @change="newpwdChange"
        ></el-input>
      </el-form-item>
      <el-form-item label="确认新密码" prop="confirmPassword">
        <el-input
          type="password"
          v-model="pwdForm.confirmPassword"
          placeholder="请确认新密码"
          @change="confirmpwdChange"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleChange">确 定</el-button>
      <el-button @click="onVisibleChange(false)">取 消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import loginFormRules from '@utils/rules/loginFormRules'
import { encryption } from '@utils/crypto'
import { updatePwd } from '@api/login'
import { validateForm } from '@utils'
import { namespace } from 'vuex-class'

const moduleUser = namespace('user')

@Component({})
export default class ChangePassword extends Vue {
  @Prop({ default: false, type: Boolean })
  visible

  @Prop({ default: '修改密码' })
  title

  @Watch('visible')
  visibleChange(val) {
    this.updatePwd = val
    this.$refs.pwdForm && this.$refs.pwdForm.resetFields()
  }

  @moduleUser.Action FeLogout

  updatePwd = false
  pwdForm = {
    confirmPassword: '',
    newPassword: '',
    oldPassword: '',
  }
  loginFormRules = loginFormRules

  onVisibleChange(val) {
    this.$emit('update:visible', val)
  }

  newpwdChange() {
    if (this.pwdForm.newPassword === this.pwdForm.oldPassword) {
      this.$message.warning('新密码和旧密码不能相同')
      return false
    } else {
      return true
    }
  }
  confirmpwdChange() {
    if (
      this.pwdForm.newPassword !== '' &&
      this.pwdForm.confirmPassword !== this.pwdForm.newPassword
    ) {
      this.$message.warning('确认密码和新密码输入不一致')
      return false
    } else {
      return true
    }
  }

  async handleChange() {
    const valid = await validateForm.call(this, 'pwdForm')
    valid && this.newpwdChange() && this.confirmpwdChange() && this.changePwd()
  }

  async changePwd() {
    // const encryptForm = encryption({
    //   data: this.pwdForm,
    //   encryptArr: ['oldPassword', 'newPassword'],
    // })
    // const res = await updatePwd({
    //   oldPassword: encryptForm.oldPassword,
    //   newPassword: encryptForm.newPassword,
    // })
    const encryptOld = encryption({
      data: this.pwdForm,
      encryptArr: ['oldPassword'],
    })
    const encryptNew = encryption({
      data: this.pwdForm,
      encryptArr: ['newPassword'],
    })
    // console.log(encryptNew.newPassword, encryptOld.oldPassword)
    const res = await updatePwd({
      oldPassword: encryptOld.oldPassword,
      newPassword: encryptNew.newPassword,
    })
    if (res.code === 0) {
      this.$message.success(res.message)
      this.onVisibleChange(false)
      await this.FeLogout()
      this.$router.push('/login')
    }
  }
}
</script>
